import React, { useState, useEffect } from 'react';
import { getData, deleteData } from '../helpers/ApiSettings';

const Messages = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMessages = async () => {
    try {
      setLoading(true);
      const response = await getData('/contact-messages?sort[0]=createdAt:desc');
      setMessages(response.data.data);
    //   console.log("response data: ", response.data.data);
      setError(null);
    } catch (err) {
      setError('Erreur lors du chargement des messages');
      console.error('Error fetching messages:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteMessage = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce message ?')) {
      try {
        await deleteData(`/contact-messages/${id}`);
        await fetchMessages(); // Refresh the list
        alert('Message supprimé avec succès');
      } catch (err) {
        alert('Erreur lors de la suppression du message');
        console.error('Error deleting message:', err);
      }
    }
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  };

  if (loading) {
    return (
      <div className="text-center p-5">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        {error}
      </div>
    );
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="h4 mb-0">Messages</h2>
        <button 
          onClick={fetchMessages} 
          className="btn btn-outline-primary"
        >
          Actualiser
        </button>
      </div>

      <div className="card">
        <div className="card-body">
          {messages.length === 0 ? (
            <p className="text-center text-muted my-5">Aucun message pour le moment</p>
          ) : (
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Nom</th>
                    <th>Email</th>
                    <th>Message</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {messages.map((message) => (
                    <tr key={message.id}>
                      <td>{formatDate(message.createdAt)}</td>
                      <td>{message.name}</td>
                      <td>
                        <a href={`mailto:${message.email}`}>
                          {message.email}
                        </a>
                      </td>
                      <td>
                        <div style={{ maxWidth: '300px' }} className="text-truncate">
                          {message.message}
                        </div>
                      </td>
                      <td>
                        <div className="btn-group">
                          <button
                            className="btn btn-sm btn-info me-2"
                            data-bs-toggle="modal"
                            data-bs-target={`#messageModal-${message.id}`}
                          >
                            Voir
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => handleDeleteMessage(message.documentId)}
                          >
                            Supprimer
                          </button>
                        </div>

                        {/* Modal for message details */}
                        <div className="modal fade" id={`messageModal-${message.id}`} tabIndex="-1">
                          <div className="modal-dialog">
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">Message de {message.name}</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                              </div>
                              <div className="modal-body">
                                <p><strong>Date:</strong> {formatDate(message.createdAt)}</p>
                                <p><strong>Email:</strong> {message.email}</p>
                                <p><strong>Message:</strong></p>
                                <p className="border p-3 bg-light">{message.message}</p>
                              </div>
                              <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                  Fermer
                                </button>
                                <a 
                                  href={`mailto:${message.email}`} 
                                  className="btn btn-primary"
                                >
                                  Répondre
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Messages;